// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  roadId: __t.u64().primaryKey().name("road_id"),
  workspaceId: __t.u64().name("workspace_id"),
  name: __t.string(),
  kind: __t.string(),
  parentRoadId: __t.u64().name("parent_road_id"),
  createdAt: __t.i64().name("created_at"),
});
